import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from '../../../../redux/projects/actions.projects';
import * as configActions from '../../../../redux/config/actions.config';
import ProgressLoader from '../../../components/ProgressLoader/ProgressLoader';
import { Loader } from '../../../components/Loader/Loader';
import platformNames from '../../../../const/platformNames';
import PopupWrapper from '../../../components/Popup/PopupWrapper';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import { getProjectOptionsByEnvironment } from '../../../../services/mini/getProjectOptionsByEnvironment';
import AlanButtonVoiceSelector from './AlanButtonVoiceSelector';
import { DEFAULT_LANGUAGE_ID, DEFAULT_REION_ID, DEFAULT_VOICE_ID } from '../../../../const/defaultVoice';
import { InfoPanel } from '../../../components/InfoPanel/InfoPanel';

function getVoiceInfo(voices, langId, regId, id, speechSpeed, speechPitch) {
    const regionNames = voices[langId][regId];
    let nameObj = _.find(regionNames, { id });

    if (speechSpeed !== undefined && nameObj?.options?.length) {
        nameObj = JSON.parse(JSON.stringify(nameObj));
        for (let i = 0; i < nameObj?.options.length; i++) {
            if (nameObj.options[i].name === 'speed') {
                nameObj.options[i] = {
                    name: 'speed',
                    type: 'range',
                    val: speechSpeed
                };
                break;
            }
        }
    }
    if (speechPitch !== undefined && nameObj?.options?.length) {
        nameObj = JSON.parse(JSON.stringify(nameObj));
        for (let i = 0; i < nameObj?.options.length; i++) {
            if (nameObj.options[i].name === 'pitch') {
                nameObj.options[i] = {
                    name: 'pitch',
                    type: 'range',
                    val: speechPitch
                };
                break;
            }
        }
    }
    return {
        [langId]: {
            [regId]: [nameObj],
        },
    };
}

class AlanButtonVoicesForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            savedVoices: [],
        };
    }

    componentDidMount() {
        this.props.getVoicesConfig();
        this.fillData();
    }

    componentDidUpdate(prevProps) {
        const { savedVoices } = this.state;
        if (_.isEmpty(savedVoices) || this.props.project.projectId !== prevProps.project.projectId) {
            this.fillData();
        }
    }

    fillData() {
        const { project, platform, environment, configVoices, cohorts, selectedCohortId } = this.props;
        const options = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId)[platform];

        if (!_.isEmpty(configVoices)) {
            this.setState({
                savedVoices: !_.isEmpty(options.voices) ?
                    this.convertSavedVoices(options.voices) :
                    [getVoiceInfo(configVoices, DEFAULT_LANGUAGE_ID, DEFAULT_REION_ID, DEFAULT_VOICE_ID)]
            });
        }
    }

    convertSavedVoices = (voices) => {
        return Object.keys(voices).map(langId => {
            const regId = Object.keys(voices[langId])[0];
            return {
                [langId]: {
                    [regId]: [voices[langId][regId]]
                }
            };
        });
    }

    convertVoicesToObj = (voices) => {
        return voices.reduce((accum, el) => {
            return { ...accum, ...el };
        }, {});
    }

    getAvailableLanguages() {
        const { configVoices } = this.props;
        const { savedVoices } = this.state;
        const availableVoices = { ...configVoices };
        let langKeys = Object.keys(this.convertVoicesToObj(savedVoices));

        for (let i = 0; i < langKeys.length; i++) {
            delete availableVoices[langKeys[i]];
        }
        return availableVoices;
    }

    addVoice = () => {
        const { savedVoices } = this.state;
        const availableVoices = this.getAvailableLanguages();
        const langId = Object.keys(availableVoices)[0];
        const regId = Object.keys(availableVoices[langId])[0];
        const id = availableVoices[langId][regId][0].id;
        const newVoice = getVoiceInfo(availableVoices, langId, regId, id);
        this.setState({ savedVoices: [...savedVoices, newVoice] }, () => {
            this.saveOptions();
        });
    }

    changeVoice = (oldLangId, langId, regId, id, speechSpeed, speechPitch) => {
        let { savedVoices } = this.state;
        const { configVoices } = this.props;

        savedVoices = savedVoices.map(voice => {
            return voice[oldLangId] ? getVoiceInfo(configVoices, langId, regId, id, speechSpeed, speechPitch) : voice;
        });

        this.setState({ savedVoices }, () => {
            this.saveOptions();
        });
    }

    removeVoice = (langId) => {
        const { savedVoices } = this.state;

        this.setState({
            savedVoices: savedVoices.filter(voiceObj => {
                return !voiceObj[langId];
            })
        }, () => {
            this.saveOptions();
        });
    }

    saveOptions = () => {
        const { project, platform, environment, cohorts, selectedCohortId } = this.props;
        const { savedVoices } = this.state;

        if (!this.canEditVoice()) return;

        let options = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId);

        let newVoices = this.convertVoicesToObj(savedVoices);
        const langKeys = Object.keys(newVoices);

        for (let i = 0; i < langKeys.length; i++) {
            const lang = langKeys[i];
            const reg = Object.keys(newVoices[lang])[0];

            if (_.isArray(newVoices[lang][reg])) {
                newVoices[lang][reg] = newVoices[lang][reg][0];
            }
        }

        options[platform].voices = newVoices;

        this.props.setProjectOptions({ project, options, environment, cohorts, selectedCohortId });
    }

    canEditVoice = () => {
        return this.props?.capabilities?.voicesSettingsAvailable;
    }

    render() {
        const {
            isProjectOptionsSaving,
            platform,
            configVoices,
            project,
            environment,
            getTextToSpeach,
            onClose
        } = this.props;

        const {
            savedVoices,
        } = this.state;

        const voicesInfo = [];
        const availableVoices = this.getAvailableLanguages();
        const canEditVoice = this.canEditVoice();
        const showAddBtn = Object.keys(availableVoices).length > 0 && canEditVoice;

        savedVoices.forEach(function (langObg) {
            const langId = Object.keys(langObg)[0];
            Object.keys(langObg[langId]).forEach(function (regId) {
                let nameInfo;
                if (_.isArray(langObg[langId][regId])) {
                    nameInfo = langObg[langId][regId][0];
                } else {
                    nameInfo = langObg[langId][regId];
                }
                if (nameInfo) {
                    voicesInfo.push({
                        langId,
                        regId,
                        id: nameInfo.id,
                        name: nameInfo.name,
                        options: nameInfo.options,
                        voiceData: getVoiceInfo(configVoices, langId, regId, nameInfo.id)
                    });
                }
            });
        });

        const hasData = !(_.isEmpty(configVoices) || voicesInfo.length === 0);

        return <PopupWrapper className="alan-button-voices-form">
            <div className="alan-button-voices-form_external-wrapper">
                <div className="popup-form_header popup-form_header_with-commands">
                    <div className="popup-form_header_cmd"
                        onClick={onClose}>
                        <i className="icon icon-alan-chevron"
                            style={{
                                transform: 'rotate(90deg)',
                                display: 'inline-block',
                                marginRight: '5px'
                            }} />
                        Back
                    </div>
                    <div>{`${platformNames[platform]} - Alan Voices`}</div>
                    <div className="popup-form_header_cmd" />
                </div>
                <div className="popup-form_internal-wrapper alan-button-voices-form_internal-wrapper">
                    <div className="alan-button-voices-form_content">
                        {(!hasData) ?
                            <Loader theme="dark" size="medium" /> :
                            <React.Fragment>
                                <InfoPanel
                                    title="You can test voices, but changes won't be saved. Change your plan to get full access to this feature."
                                    visible={!canEditVoice}
                                    className="alan-button-voices-form_info-panel" />
                                <div className="alan-button-voices-form_content-header">
                                    <div>Language</div>
                                    <div>Region</div>
                                    <div>Voice</div>
                                </div>
                                {voicesInfo.map((voice, i) => {
                                    return <AlanButtonVoiceSelector
                                        key={voice.langId}
                                        project={project}
                                        environment={environment}
                                        platform={platform}
                                        showRemoveBtn={voicesInfo.length !== 1}
                                        langId={voice.langId}
                                        regId={voice.regId}
                                        id={voice.id}
                                        voiceInfo={voice}
                                        voices={{ ...{ [voice.langId]: configVoices[voice.langId] }, ...availableVoices }}
                                        changeVoice={this.changeVoice}
                                        removeVoice={this.removeVoice}
                                        getTextToSpeach={getTextToSpeach}

                                    />;
                                })}
                                {showAddBtn && <div className="alan-button-voices-form_col">
                                    <div className="action-btn alan-button-voices-form_add-voice-btn"
                                        onClick={this.addVoice}>
                                        + Add Language
                                    </div>
                                </div>}
                            </React.Fragment>}
                    </div>
                </div>
            </div>
        </PopupWrapper>;
    }
}

function mapStateToProps({ projectsInfo, config, user }) {
    return {
        isProjectOptionsSaving: projectsInfo.isProjectOptionsSaving,
        configVoices: config.voices,
        capabilities: user.capabilities
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getVoicesConfig: (param) => asyncDispatch(configActions.getVoicesConfig, dispatch, param),
        setProjectOptions: (param) => asyncDispatch(actions.setProjectOptions, dispatch, param),
        getTextToSpeach: (param) => asyncDispatch(actions.getTextToSpeach, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AlanButtonVoicesForm);